export const useSxStyles = () => {
  return {
    root: {
      padding: '5px 0 40px 15px',
    },
    headingIcon: {
      color: '#555',
      fontSize: 16,
    },
    heading: {
      fontWeight: 'bold',
      fontSize: 15,
    },
    divider: {
      my: '15px',
      borderColor: '#D6D6D6',
    },
  };
};
